<template>
    <!--<div class="callUp">-->
    <!--<div class="callUpContent">-->
    <!--<div class="cucClose" @click="close"><img src="../../assets/icon_close.png" alt=""></div>-->
    <!--<div class="cucTop" v-for="item in publicData.ContactInfo">-->
    <!--<div class="cucTopTitle"><span>请联系：</span><span>{{item.Name}}</span></div>-->
    <!--<div class="cucTopNumber"><span>{{item.Phone}}</span><span class="ctnNumber">微信号：</span><span>{{item.WxCode}}</span></div>-->
    <!--<div class="cucTopCopy" :data-clipboard-text="item.WxCode" @click="copy">【点此一键复制】  去微信></div>-->
    <!--<a :href="'tel:'+item.Phone" class="cucTopTelphone">拨打电话</a>-->
    <!--</div>-->
    <!--</div>-->
    <!--</div>-->

    <div class="callUp">
        <div class="callUpContent">
            <div class="callUpContentTitle">一 联系我们快速询价 一</div>
            <div class="callUpContentList">
                <div class="item" v-for="item in publicData.ContactInfo">
                    <div class="row clearfix">
                        <div class="column-3">{{item.Name}}</div>
                        <div class="column-4"><span class="phone"></span>{{item.Phone}}</div>
                        <div class="column-3"><a :href="'tel:'+item.Phone" class="cucTopTelphone">拨打</a></div>
                    </div>
                    <div class="row clearfix">
                        <div class="column-3"></div>
                        <div class="column-4"><span class="wechat"></span>{{item.WxCode}}</div>
                        <div class="column-3"><a class="copyBtn" href="javascript:void (0)" @click="copy" :data-clipboard-text="item.WxCode">复制微信号</a></div>
                    </div>
                </div>
            </div>
            <div class="callUpContentMessage">
                <div class="message clearfix">
                    <input type="text" maxlength="11" v-model="phone" placeholder="输入手机号码，我们马上来帮您">
                    <a href="javascript:void(0)" @click="submit">提交</a>
                </div>
            </div>
        </div>
        <a class="callUpClose" @click="close" href="javascript:void(0)"></a>
    </div>
</template>

<script>
    import Clipboard from 'clipboard';
    import {Toast} from 'vant';
    export default {
        name: '',
        components: {},
        props:['publicData'],
        data () {
            return {
                copyBtn:null,
                phone:'',
            }
        },
        mounted(){
            this.copyBtn = new Clipboard(".copyBtn");
        },
        methods:{
            close(){
                let skt = false;
                this.$emit("footCall",skt);
            },
            copy(){
                let clipboard = this.copyBtn;
                clipboard.on('success', function(e) {
                    console.log(e);
                    Toast({type:'html',message:'复制成功，请到微信搜索',onClose() {
                            window.location.href='weixin://';
                        }});
                });
                clipboard.on('error', function(e) {
                    console.log(e);
                    Toast({type:'html',message:'复制失败'});
                });
            },
            submit:function () {
                var that = this;
                if(this.phone){
                    this.axios.post('http://travel.xiangbaoche.cn/api.php/api/Gbook/index',
                        {
                            phone:that.phone,
                            city_id:that.publicData.Cityaid,
                            type:1,
                            site_type:2,
                            site:4,
                        }
                    ).then(function (res) {
                        console.log(res);
                        if(res.data.resCode == 1){
                            Toast('您的留言已提交成功，工作人员15分钟内回复您。');
                            that.close();
                        }else {
                            Toast({type:'html',message:res.data.resMsg,onClose() {

                                }});
                        }
                    }).catch(function (err) {
                        console.log(err);
                        Toast("提交失败，请稍后重试");
                    });
                }else {
                    Toast('请填写您的联系方式，方便客服联系您');
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--<style scoped>-->
<!--.clear {overflow: hidden;}-->
<!--.clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}-->

<!--.callUp{width: 606px;position: fixed;left: 72px;top:172px;background: #ffffff;z-index: 9;line-height: normal;}-->
<!--.callUpContent{margin: 0 60px;position: relative;padding: 76px 0 60px 0}-->
<!--.cucClose{width: 36px;height: 36px;position: absolute;right: 0;top:40px;}-->
<!--.cucClose img{width: 100%;height: 100%}-->

<!--.cucTop{text-align: left;margin-bottom: 40px;}-->
<!--.cucTopTitle{font-size:32px;font-family:PingFangSC-Medium;font-weight:700;color:rgba(44,62,80,1);}-->
<!--.cucTopNumber{margin-top: 24px;font-size:32px;font-family:PingFangSC-Regular;font-weight:400;color:rgba(29,210,175,1);}-->
<!--.ctnNumber{color: #4d667e;margin-left: 30px}-->
<!--.cucTopCopy{font-size:32px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(238,69,71,1);text-align: center;margin-top: 20px}-->
<!--.cucTopTelphone{display:block;width: 100%;height: 68px;line-height: 68px;background: #1dd2af;color: #ffffff;font-size:28px;font-family:PingFangSC-Regular;font-weight:400;text-align: center;margin-top: 20px;border-radius:4px;}-->
<!--.cucBottom{margin-top: 48px}-->
<!--</style>-->
<style scoped>
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}
    .callUp{width: 90%;position: absolute;left: 5%;top: 300px;z-index: 9;}
    .callUpContent{background-color: #fff;border-radius: 10px;overflow: hidden;}
    .callUpContentTitle{height: 100px;line-height: 100px;text-align: center;background-color: #1dd2af;font-size: 36px;font-weight: bold;color: #333;}
    .callUpContentList{padding:0 30px;}
    .callUpContentList .item{padding-bottom: 30px;border-bottom: 1px solid #ddd;}
    .callUpContentList .item .row{margin-top: 20px;}
    .callUpContentList .item .row .column-3{float: left;width: 30%;height: 60px;line-height:60px;text-align: left;font-size: 28px;}
    .callUpContentList .item .row .column-4{float: left;width: 40%;height: 60px;line-height:60px;text-align: left;font-size: 28px;}
    .phone{display:inline-block;width: 24px;height: 26px;background: url("../../assets/callUpPhone.png") no-repeat;background-size: 100% 100%;margin-right: 10px;}
    .wechat{display:inline-block;width: 30px;height: 24px;background: url("../../assets/callUpWechat.png") no-repeat;background-size: 100% 100%;margin-right: 10px;}
    .cucTopTelphone{display:block;width: 100%;height: 100%;background-color: #1dd2af;border-radius: 6px;color: #333;font-weight: bold;text-align: center;}
    .copyBtn{display:block;width: 100%;height: 100%;border-radius: 6px;color: #333;border: 1px solid #AFAFAF;text-align: center;box-sizing: border-box;}
    .callUpClose{display: block;width: 80px;height: 80px;margin: 100px auto 0;background: url("../../assets/callUpClose.png") no-repeat;background-size: 100% 100%;}
    .callUpContentMessage{padding: 30px;}
    .message{width: 100%;height: 60px;line-height: 60px;border-radius: 30px;border: 1px solid #1dd2af;overflow: hidden;}
    .message input{float:left;display:block;width: 80%;height: 100%;padding: 10px 30px;font-size: 26px;box-sizing: border-box;border: none;}
    .message a{float:left;display: block;width: 20%;height: 100%;background-color: #1dd2af;font-size: 30px;color: #333;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/components/CallUp/CallUp.vue